/**
 * region for libraries*/
import React, { Component } from 'react';
import { Button, ModalBody, ModalFooter } from 'reactstrap';

/**
 * region for components*/
import { InputText } from '../../InputText';

/**
 * region for helpers*/
import validation from '../../../../helpers/validation';


export class Step0 extends Component {
    static displayName = Step0.name;

    constructor(props) {
        super(props);

        this.state = {
            keywordText: props.keywordText
        };

        this.validableCollection = [];
        this.keywordText = props.keywordText;
    }

    includeValidableComponent(validableComponent) {
        this.validableCollection.push(validableComponent);
    }

    handleNext() {
        const self = this;
        validation.validate(self.validableCollection, function () {
            if (self.props.onkeywordTextUpdated) {
                self.props.onkeywordTextUpdated(self.keywordText);
            }
            if (self.props.handleNext) {
                self.props.handleNext();               
            }
        });

    }

    handleOnClose() {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    handleChangeValue(value, fieldName) {
        this.keywordText = value;
    }

    render() {
        
        const acceptButtonClass = (this.props.acceptButton && this.props.acceptButton.className) || 'btn';
        const acceptButtonText = (this.props.acceptButton && this.props.acceptButton.text) || 'NEXT';

        return (
            <div>
                <ModalBody className="font-size-md">  
                    <div className="mt-4 p-4">
                        <InputText
                            tableName="KEYWORDS"  
                            fieldName="KEYWORD"   
                            className="form-control form-control-lg"
                            setInputValue={this.handleChangeValue.bind(this)}
                            value={this.state.keywordText}
                            validationAsTooltip={true}
                            includeValidableComponent={this.includeValidableComponent.bind(this)} /> 
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="" onClick={this.handleOnClose.bind(this)}>CANCEL</Button>
                    <Button color="secondary" className={acceptButtonClass} onClick={this.handleNext.bind(this)}>{acceptButtonText}<i className="far fa-play-circle ml-1"></i></Button>{' '}
                </ModalFooter>
            </div>
        );
    }
}
